module.exports = __webpack_public_path__ + "static/prizes-hero-faad82653b0c93b54fbc7efb4d64a2d6.png";